import React from 'react';
import PDFViewer from 'mgr-pdf-viewer-react';

const FilePDF = (props) => {
    const {question} = props;

    let urlPDF = `${process.env.REACT_APP_CMS_BASE_URL}/${question.hasPdf}`;

    if (question.hasPdf) {
        return (
            <div className="wap-pdf">
                <PDFViewer document={{
                    url: urlPDF,
                }}/>
            </div>
        );
    }
    return <></>
};

export default FilePDF;
